import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OccProductSearchAdapter } from '@spartacus/core';
import { FacetComponent, FacetService } from '@spartacus/storefront';
import { ProductListService } from '../../../../kbs-site-doc-search-page/service/Product-list/product-list.service';


@Component({
  selector: 'app-facet-kb',
  templateUrl: './facet-kb.component.html',
  styleUrls: ['./facet-kb.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class FacetKbComponent extends FacetComponent implements OnDestroy {
  showContent!: boolean;
  categoryCode: any;
  defaultPageSize: number = 10;
  initalPageNum: number = 0;
  @Input() facetTabName: any;
  model$: any;

  constructor(
    facetService: FacetService,
    elementRef: ElementRef<HTMLElement>,
    private activatedRoute: ActivatedRoute,
    private productListService: ProductListService,
    public searchService: OccProductSearchAdapter,
    cd: ChangeDetectorRef
  ) {
    super(facetService, elementRef, cd);
  }
  ngOnDestroy(): void {
    // this.productListService.seperateSoftDetails$.next(null);
    // this.productListService.seperateDocDetails$.next(null)
  }
  ngOnInit() {
    if (window.location.href.includes('documentLibrary')) {
      this.productListService.countDetails$.next(null);
      //this.productListService.countDetails$.unsubscribe();
    }
    this.activatedRoute.params.subscribe((data) => {
      this.categoryCode = data?.['categoryCode'];
    });
  }
  FacetClick(e: any, FacetName: number) {
    const queryValue = this.productListService.DecodeQuery(e.query.query.value);
   /*  if (FacetName == 2) {
      this.productListService
        .getDocumentDetails(this.defaultPageSize, queryValue, this.initalPageNum)
        .subscribe((data) => {
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            docModel: data,
          });
        });
    } else if (FacetName == 3) {
      this.productListService
        .getSoftwareDetails(this.defaultPageSize, queryValue, this.initalPageNum)
        .subscribe((data) => {
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            softwareModel: data,
          });
        });
    } else if (FacetName == 1) {
      this.productListService
        .getCrossRefDetails(this.defaultPageSize, queryValue, this.initalPageNum)
        .subscribe((data) => {
          data = this.removeSortAndAssignEmpty(data);
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            crossRefModel: data,
          });
        });
      // this.productListService.getCrossRefDetails(this.defaultPageSize, queryValue, this.initalPageNum);
    } else if (FacetName == 4) {
      this.productListService
        .getTrainingDetails(this.defaultPageSize, queryValue, this.initalPageNum)
        .subscribe((data) => {
          this.productListService.countDetails$.next({
            ...this.productListService.countDetails$.value,
            trainingModel: data,
          });
        });
    } else if (FacetName == 0) {
      this.searchService.search(queryValue).subscribe((data) => {
        data = this.removeSortAndAssignEmpty(data);
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      });
    } else */ if (FacetName == 7) {
      const docQuery = this.productListService.getCustomDocQuery(e.query.query.value);
      this.productListService
        .getCustomDocumentDetails(docQuery, this.defaultPageSize, this.initalPageNum)
        .subscribe((x) => {
          this.productListService.seperateDocDetails$.next(x);
        });
    } /* else if (FacetName == 8) {
      const softQuery = this.productListService.getCustomSoftwareQuery(e.query.query.value);
      this.productListService
        .getCustomSoftwareDetails(softQuery, this.defaultPageSize, this.initalPageNum)
        .subscribe((x) => {
          this.productListService.seperateSoftDetails$.next(x);
        });
    } */
  }

  removeSortCode(data: any[]) {
    return data?.filter((sort) => sort.code !== 'salesStatusSortValue-asc');
  }
  removeSortAndAssignEmpty(productModel: { sorts: any[]; pagination: { sort: string; }; }) {
    return {
      ...productModel,
      sorts: this.removeSortCode(productModel.sorts),
      pagination: {
        ...productModel.pagination,
        sort: productModel.pagination.sort !== 'salesStatusSortValue-asc' ? productModel.pagination.sort : null,
      },
    };
  }
}
